import {Option} from "ts-option";
import {Moment} from "moment";

/**
 * Option utils.
 */
export default class OptionUtils {

	/**
	 * Check if two options are the same.
	 * @param o1 option 1.
	 * @param o2 option 2
	 * @param comparator
	 * @return true - options are the same.
	 */
	static isTheSame<T>(o1: Option<T>, o2: Option<T>, comparator: (o1: T, o2: T) => boolean = (o1, o2) => o1 == o2): boolean {
		return (o1.isEmpty && o2.isEmpty) || (o1.isDefined && o2.isDefined && o1.get == o2.get)
	}

	static isTheSameMoment(o1: Option<Moment>, o2: Option<Moment>): boolean {
		return this.isTheSame(o1, o2, (d1, d2) => !!d1.diff(d2))
	}
}